// extracted by mini-css-extract-plugin
export default {"expandableText":"expandableText_expandableText__9lgoc","aboveThreshold":"expandableText_aboveThreshold__YfrSc"};